import { PromotionEventType, PromotionEventUrlClickAndCollectType } from "./promotion-event.request.model";

export class PromotionEventResponse{
    analyticsCode: string;
    createdAt: string;
    createdBy: string;
    modifiedAt: string;
    modifiedBy: string;
    expirationTime: string;
    id: number;
    name: string;
    published: boolean;
    startTime: string;
    
}

export class PromotionEventResponseTable{
    data: PromotionEventResponse[];
    limit: number;
    page: number;
    total: number;
    
}

export class PromotionEventResponseList extends PromotionEventResponseTable{
    constructor(){super();}
}

export class PromotionEventResponseGet{
    analyticsCode: string;
    createdAt: string;
    createdBy: string;
    description: string;
    description2: string;
    expirationTime: string;
    id: number;
    landingPagePromotion: string;
    modifiedAt:	string;
    modifiedBy: string;
    name: string;
    promotionAppointment: boolean;
    promotionVisibility: boolean;
    published: boolean;
    seoDescription: string; 
    seoId: string;
    seoTitle: string;
    startTime: string;
    type: PromotionEventType;	
    urlClickAndCollectType: PromotionEventUrlClickAndCollectType;
    
}

export class PromotionEventResponseSearch extends PromotionEventResponseTable{
    constructor(){super();}
}